import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'

import { optInitialSetupServiceOrderApi } from '@services/api/optInitialSetupServiceOrderApi'

const initOPTInitialSetupServiceOrderDetail: TOPTInitialSetupService.TState['initialSetupOrderDetail'] = {
  data: {
    id: '',
    orderNumber: '',
    storeId: '',
    storeName: '',
    storeCD: '',
    storeManagerId: '',
    personInChargeName: '',
    email: '',
    dataEntryService: false,
    menuShootingService: false,
    option1Start: '',
    option1End: '',
    option2Start: '',
    option2End: '',
    option3Start: '',
    option3End: '',
    status: 0,
    type: '',
    createdAtUtc: '',
    other: ''
  }
}

const initOPTInitialSetupServiceOrderListData: TOPTInitialSetupService.TState['optInitialSetupServiceOrderList'] = {
  data: [],
  pageIndex: 1,
  pageSize: 20,
  totalRecords: 0,
  totalPage: 1,
  hasNextPage: false,
  hasPreviousPage: false
}

const initialState: TOPTInitialSetupService.TState = ({
  optInitialSetupServiceOrderList: initOPTInitialSetupServiceOrderListData,
  isfetchingOrders: false,
  initialSetupOrderDetail: initOPTInitialSetupServiceOrderDetail,
  isLoading: false,
  filter: {
    term: '',
    fromDate: null,
    toDate: null,
    status: null,
    PageSize: 20,
    PageIndex: 1
  }
})

export const fetchOPTInitialSetupServiceOrderList = createAsyncThunk(
  'optInitialSetupServiceOrder/fetchList',
  async (params: TOPTInitialSetupService.FetchList, { rejectWithValue }) => {
    try {
      const response = await optInitialSetupServiceOrderApi.fetchList(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchSingle = createAsyncThunk(
  'optInitialSetupServiceOrder/fetchSingle',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await optInitialSetupServiceOrderApi.fetchSingle(id)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const saveChangeStatus = createAsyncThunk(
  'optInitialSetupServiceOrder/saveChangeStatus',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await optInitialSetupServiceOrderApi.saveChangeStatus(data)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

const optInitialSetupServiceOrderSlice = createSlice({
  name: 'optInitialSetupServiceOrder',
  initialState,
  reducers: {
    setLoading (state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload
    },
    changeDetailStatus (state, action) {
      state.initialSetupOrderDetail.data.status = action.payload
    },
    changeSearchTerm (state, action) {
      state.filter.term = action.payload
    },
    changeSearchFromDate (state, action) {
      state.filter.fromDate = action.payload
    },
    changeSearchToDate (state, action) {
      state.filter.toDate = action.payload
    },
    changeSearchStatus (state, action) {
      state.filter.status = action.payload
    },
    changeSearchPageIndex (state, action) {
      state.filter.PageIndex = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchOPTInitialSetupServiceOrderList.fulfilled, (state, action: PayloadAction<TOPTInitialSetupService.TState['optInitialSetupServiceOrderList']>) => {
        if (!action.payload) return
        state.optInitialSetupServiceOrderList = action.payload
        if (!state.optInitialSetupServiceOrderList.data?.length) {
          state.optInitialSetupServiceOrderList = action.payload
        }
        state.isfetchingOrders = false
      })
      .addCase(fetchSingle.fulfilled, (state, action: PayloadAction<TOPTInitialSetupService.TState['initialSetupOrderDetail']>) => {
        state.isLoading = false
        if (!action.payload?.data) return
        state.initialSetupOrderDetail.data = action.payload.data
      })
      .addCase(fetchSingle.pending, state => {
        state.isLoading = true
      })
  }
})

export const {
  setLoading,
  changeDetailStatus,
  changeSearchStatus,
  changeSearchToDate,
  changeSearchFromDate,
  changeSearchTerm,
  changeSearchPageIndex
} = optInitialSetupServiceOrderSlice.actions

export const optInitialSetupServiceOrderReducer = optInitialSetupServiceOrderSlice.reducer
export default optInitialSetupServiceOrderSlice.reducer
